import { createReducer, on } from '@ngrx/store';
import {
  ClearSearchLiteralsFilters,
  FindLiteralsByLanguageSuccess,
  GetAvailableLanguagesSuccess,
  LiteralCodeChanged,
  LiteralTextChanged,
  PanelStatusChanged,
} from '../actions/search-literals.actions';
import { Language } from '../models/literals.model';
import { GetSelectedLanguageSuccess } from 'src/app/shared/actions/literals.actions';

export interface LiteralsSearchState {
  panelExpanded: boolean;
  literalCode: string;
  literalText: string;
  availableLanguages: Language[];
  selectedLanguage: string;
  literals: any;
}

const initialState: LiteralsSearchState = {
  panelExpanded: true,
  literalCode: '',
  literalText: '',
  availableLanguages: [],
  selectedLanguage: '',
  literals: '',
};

export const LiteralsSearchReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(LiteralCodeChanged, (state, { literalCode }) => ({
    ...state,
    literalCode,
  })),
  on(LiteralTextChanged, (state, { literalText }) => ({
    ...state,
    literalText,
  })),
  on(ClearSearchLiteralsFilters, (state) => ({
    ...state,
    panelExpanded: true,
    literalCode: '',
    literalText: '',
  })),
  on(GetAvailableLanguagesSuccess, (state, { res }) => ({
    ...state,
    availableLanguages: res,
  })),
  on(GetSelectedLanguageSuccess, (state, { selectedLanguage }) => ({
    ...state,
    selectedLanguage,
  })),
  on(FindLiteralsByLanguageSuccess, (state, { res }) => ({
    ...state,
    literals: res,
  })),
);
